'use client';

import { BlurContext } from '@/context/BlurContext';
import { isUndefined } from 'lodash';
import { useSessionStorage } from 'react-use';

export const BlurProvider = ({ children }: { children: React.ReactNode }) => {
  const [isBlur, setIsBlur] = useSessionStorage('isBlur', false);

  const toggleBlur = (value?: boolean) => {
    setIsBlur(isUndefined(value) ? !isBlur : value);
  };

  return (
    <BlurContext.Provider value={{ isBlur, toggleBlur }}>
      {children}
    </BlurContext.Provider>
  );
};
